import React from 'react';
import { Link } from 'react-router-dom';
import { Bell, LogOut, Menu } from 'lucide-react';
import { ROUTES } from '../../config/routes.config';
import { useUIStore } from '../../store/uiStore';
import { useNotificationStore } from '../../store/notificationStore';
import { useAuthStore } from '../../store/authStore';

const Header: React.FC = () => {
  const { toggleSidebar, toggleMobileSidebar } = useUIStore();
  const { unreadCount } = useNotificationStore();
  const { user, logout } = useAuthStore();

  return (
    <header
      className="flex items-center justify-between px-4"
      style={{
        height: 'var(--header-height)',
        minHeight: 'var(--header-height)',
        flexShrink: 0,
        backgroundColor: 'var(--bg-card)',
        boxShadow: 'var(--shadow-sm)',
      }}
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={toggleMobileSidebar}
          className="md:hidden inline-flex items-center justify-center rounded-md p-2 text-[var(--color-gray-600)] hover:bg-[var(--color-gray-100)]"
          aria-label="Toggle sidebar"
        >
          <Menu className="h-5 w-5" />
        </button>
        <div className="hidden md:block text-md text-muted">
          Welcome, {user?.name || 'Officer'}
        </div>
      </div>

      <div className="flex items-center gap-4">
        <Link
          to={ROUTES.NOTIFICATIONS}
          className="relative inline-flex items-center justify-center rounded-full h-9 w-9 hover:bg-[var(--color-gray-100)]"
          aria-label="Notifications"
        >
          <Bell className="h-5 w-5 text-[var(--color-gray-600)]" />
          {unreadCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 inline-flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-[var(--color-error)] text-[10px] text-white px-1">
              {unreadCount > 99 ? '99+' : unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </Link>

        <button
          type="button"
          onClick={logout}
          className="inline-flex items-center gap-1 rounded-md border border-[var(--color-gray-200)] px-2 py-1 text-sm text-[var(--color-gray-700)] hover:bg-[var(--color-gray-100)]"
        >
          <LogOut className="h-3 w-3" />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;

